import React from 'react';
import PageHeader from '../components/PageHeader';
import ReviewsSection from '../components/ReviewsSection';
import CTABoxes from '../components/CTABoxes';

const ReviewsPage = () => {
  return (
    <>
      <PageHeader
        eyebrow="Customer Reviews"
        title="What Our Customers Say"
        description="5-star rated on Google and hipages — trusted by homeowners and businesses across Melbourne."
      />
      <ReviewsSection />
      <CTABoxes />
    </>
  );
};

export default ReviewsPage;
